export function removalStatus(current, fleet) {
    if (!current?.unmanage) return null;

    if (!fleet || fleet.desiredGeneration !== current.generation) {
        return {
            tone: "neutral",
            label: "Removal status unavailable",
            detail: `Fleet status for the removal (v${current.generation}) is not available yet.`,
        };
    }

    const knownTotal = fleet.knownTotal ?? fleet.total;
    if (!knownTotal) {
        return {
            tone: "neutral",
            label: "Removal not confirmed",
            detail: "No known endpoints have a removal status, so removal cannot be confirmed.",
        };
    }

    const effective = fleet.categories.find((category) => category.id === "effective")?.count ?? 0;
    if (effective === knownTotal) {
        return {
            tone: "good",
            label: "Removal effective",
            detail: `All ${knownTotal.toLocaleString()} known endpoints applied the removal (v${current.generation}).`,
        };
    }

    return {
        tone: "warning",
        label: "Removal not confirmed",
        detail: `${(knownTotal - effective).toLocaleString()} of ${knownTotal.toLocaleString()} known endpoints have not applied the removal (v${current.generation}) yet.`,
    };
}
